import { formatDate, toIsoDate } from "@/helpers/author";

export default {
  name: "author-byline",
  props: {
    author: {
      type: Object,
      required: true,
    },
    publishedAt: {
      type: String,
      default: "",
    },
    updatedAt: {
      type: String,
      default: "",
    },
  },
  computed: {
    isUpdated() {
      return !!this.updatedAt && toIsoDate(this.updatedAt) !== toIsoDate(this.publishedAt);
    },
    authorLink() {
      return this.$localize({ name: "author", params: { slug: this.author.slug } });
    },
  },
  methods: {
    format(date) {
      return formatDate(date);
    },
    toIso(date) {
      return toIsoDate(date);
    },
  },
};
